import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'component/Modal/GenericModal'
import Button from '../Button'

const ExclusionModal = ({
  buttonText,
  t,
  title,
  confirmButtonMsg = 'new.home.quickAccess.remove.confirm',
  cancelButtonMsg = 'new.home.quickAccess.remove.cancel',
  message,
  renderButton,
  onConfirm: confirmCallback,
  size = 'md'
}) => (
  <Modal
    buttonText={buttonText}
    center
    size={size}
    className="justifications-irc-delete-modal"
    showHeader={false}
    showFooter={false}
    renderButton={renderButton}
    renderChildrenWithProps={({ onClose, onConfirm }) => (
      <div className='remove-modal'>
        <i className='glyph glyph-trash-can color-danger' />
        <p style={{marginTop: '17px'}} className='title'>{title}</p>
        {typeof message === 'function' ? message() : <p>{message}</p>}
        <div style={{marginTop: '40px'}} className='button-row'>
          <Button
            className='btn custom-modal-close-button'
            text={t(cancelButtonMsg)}
            onClick={onClose}
          />
          <Button
            className='btn btn-danger'
            text={t(confirmButtonMsg)}
            onClick={() => {
              confirmCallback && confirmCallback()
              onConfirm && onConfirm()
            }}
          />
        </div>
      </div>
    )}
  />
)

ExclusionModal.propTypes = {
  buttonText: PropTypes.string,
  title: PropTypes.string.isRequired,
  message: PropTypes.any.isRequired,
  onConfirm: PropTypes.func.isRequired,
  renderButton: PropTypes.func,
  t: PropTypes.func.isRequired,
  confirmButtonMsg: PropTypes.string,
  cancelButtonMsg: PropTypes.string,
  size: PropTypes.string,
}

export default ExclusionModal
